import React from 'react';
import { Link } from 'gatsby';
import { GatsbyImage, getImage, StaticImage } from 'gatsby-plugin-image';
import { CustomPopover } from '../../../cs/common/components/custom-popover';
import { IHSRCharacter } from '../../../common/model/graphql-types';
import { HSRCharacterPopover } from './hsr-popover';
import { faWandSparkles } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface IProps {
  employee: IHSRCharacter;
  enablePopover?: boolean;
  showLabel?: boolean;
  showTags?: boolean;
  showIcon?: boolean;
  showTierListchange?: boolean;
  showEidolon?: boolean;
  eidolonSpecial?: boolean;
}

export const HSRCharacterCard: React.FC<IProps> = ({
  employee,
  showLabel,
  enablePopover,
  showTags,
  showIcon,
  showTierListchange
}) => {
  const image = employee.cardImage
    ? getImage(employee.cardImage.localFile.childImageSharp)
    : null;
  return (
    <CustomPopover
      enabled={enablePopover}
      customClass="character-hover-box hsr"
      popover={<HSRCharacterPopover character={employee} />}
    >
      <Link to={'/star-rail/characters/' + employee.slug}>
        <div
          className={`avatar card hsr rarity-${employee.rarity} ${
            showLabel ? showLabel : ''
          }`}
        >
          {image && (
            <GatsbyImage
              className="disable-transition"
              image={image}
              alt={`${employee.name}`}
            />
          )}
          {showLabel && <span className="emp-name">{employee.name}</span>}
          {showLabel && employee.isNew && showTags && (
            <span className="tag new">New</span>
          )}
          {showLabel && !employee.isReleased && showTags && (
            <span className="tag future">
              {employee.slug === 'castorice' || employee.slug === 'anaxa'
                ? '3.2'
                : '3.3'}
            </span>
          )}
        </div>
        {showIcon && (
          <span className="floating-element">
            {employee.element === 'Physical' && (
              <StaticImage
                src="../../../../images/starrail/icons/ele_phys_new.png"
                alt={employee.element}
              />
            )}
            {employee.element === 'Fire' && (
              <StaticImage
                src="../../../../images/starrail/icons/ele_fire_new.png"
                alt={employee.element}
              />
            )}
            {employee.element === 'Ice' && (
              <StaticImage
                src="../../../../images/starrail/icons/ele_ice_new.png"
                alt={employee.element}
              />
            )}
            {employee.element === 'Wind' && (
              <StaticImage
                src="../../../../images/starrail/icons/ele_wind_new.png"
                alt={employee.element}
              />
            )}
            {employee.element === 'Lightning' && (
              <StaticImage
                src="../../../../images/starrail/icons/ele_lightning_new.png"
                alt={employee.element}
              />
            )}
            {employee.element === 'Quantum' && (
              <StaticImage
                src="../../../../images/starrail/icons/ele_quantum_new.png"
                alt={employee.element}
              />
            )}
            {employee.element === 'Imaginary' && (
              <StaticImage
                src="../../../../images/starrail/icons/ele_img_new.png"
                alt={employee.element}
              />
            )}
          </span>
        )}
        {showTierListchange && employee.tierListNew && (
          <span className="floating-element tier-list-hsr new">
            <FontAwesomeIcon icon={faWandSparkles} width="18" />
          </span>
        )}
      </Link>
    </CustomPopover>
  );
};
